import { SubscriptionState } from './state';
import { subscriptionInitialState } from './initial-state';
import { SubscriptionActions } from './action-creators';
import * as actions from './actions';

export const subscriptionReducer = (
  state: SubscriptionState = subscriptionInitialState,
  action: SubscriptionActions
): SubscriptionState => {
  switch (action.type) {
    case actions.CLEAR_SUBSCRIPTIONS: {
      return {
        ...state,
        current: undefined,
        invoices: [],
      };
    }

    case actions.GET_SUBSCRIPTION: {
      return {
        ...state,
        subscriptionCreated: false,
        current: undefined,
      };
    }

    case actions.CREATE_SUBSCRIPTION: {
      return {
        ...state,
        subscriptionCreated: false,
      };
    }

    // case actions.GET_LABEL_SUBSCRIPTION: {
    //   return {
    //     ...state,
    //     label: {
    //       ...state.label,
    //       [action.clientId]: undefined
    //     },
    //   };
    // }

    case actions.GET_SUBSCRIPTION_SUCCESS: {
      return {
        ...state,
        current: action.subscription,
      };
    }

    case actions.CANCEL_SUBSCRIPTION_SUCCESS: {
      return {
        ...state,
        current: action.subscription,
      };
    }

    case actions.GET_LABEL_SUBSCRIPTION_SUCCESS: {
      return {
        ...state,
        label: {
          ...state.label,
          [action.subscription.clientId]: action.subscription,
        },
      };
    }

    case actions.CREATE_SUBSCRIPTION_SUCCESS: {
      return {
        ...state,
        subscriptionCreated: true,
        current:
          action.subscriptionType === 'artist'
            ? action.newSubscription
            : state.current,
        label: {
          ...state.label,
          ...(action.subscriptionType === 'record-label'
            ? { [action.newSubscription.clientId]: action.newSubscription }
            : {}),
        },
      };
    }

    case actions.GET_INVOICES: {
      return {
        ...state,
        invoices: [],
      };
    }

    case actions.GET_INVOICES_SUCCESS: {
      return {
        ...state,
        invoices: action.invoices,
      };
    }

    default: {
      return { ...state };
    }
  }
};
